import React from 'react'
import { useContent } from '../../services'
import analytics from '../../services/analytics'

function CallReservation() {
    const { data: businessInfo, loading } = useContent('businessInfo');

    if (loading || !businessInfo) return null;

    return (
        <section className="call-reservation-section">
            <div className="call-rsv-box">
                <div className="call-rsv-inner">

                    {/* ─── Left: CTA Column ─── */}
                    <div className="call-rsv-cta">
                            <div className="call-rsv-separator">
                                <img src={require('../../assets/images/icons/separator.svg').default} alt="" />
                            </div>
                            <div className="call-rsv-overline">Table Reservations</div>
                            <h2 className="call-rsv-title">
                                Let Us Set the<br />Table for You
                            </h2>
                            <p className="call-rsv-subtitle">
                                Call us to reserve your perfect table — we'll handle the rest.
                                Ideal for celebrations, group dining, or a memorable night out.
                            </p>
                            <a href={businessInfo.phoneLink} className="call-rsv-btn" onClick={() => analytics.trackPhoneClick('reservation_cta')}>
                                <span className="call-rsv-btn__ring">
                                    <span className="fas fa-phone-alt"></span>
                                </span>
                                <span className="call-rsv-btn__text">
                                    <span className="call-rsv-btn__label">Call to Reserve</span>
                                    <span className="call-rsv-btn__number">{businessInfo.phone}</span>
                                </span>
                            </a>
                        </div>

                        {/* ─── Right: Hours Column ─── */}
                        <div className="call-rsv-sidebar">
                            <div className="call-rsv-hours-card">
                                <div className="call-rsv-hours-card__badge">
                                    <span className="far fa-clock"></span>
                                </div>
                                <h4 className="call-rsv-hours-card__title">Open Hours</h4>
                                <div className="call-rsv-hours-card__divider"></div>
                                <div className="call-rsv-hours-card__row">
                                    <div className="call-rsv-hours-card__day">
                                        <span className="call-rsv-hours-card__dot"></span>
                                        Sunday – Thursday
                                    </div>
                                    <div className="call-rsv-hours-card__time">
                                        {businessInfo.openTime} – {businessInfo.closeTimeSunThu}
                                    </div>
                                </div>
                                <div className="call-rsv-hours-card__row">
                                    <div className="call-rsv-hours-card__day">
                                        <span className="call-rsv-hours-card__dot"></span>
                                        Friday – Saturday
                                    </div>
                                    <div className="call-rsv-hours-card__time">
                                        {businessInfo.openTime} – {businessInfo.closeTimeFriSat}
                                    </div>
                                </div>
                                <div className="call-rsv-hours-card__divider"></div>
                                <div className="call-rsv-hours-card__note">
                                    <span className="fas fa-utensils"></span> Walk-ins are always welcome
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
        </section>
    )
}

export default CallReservation
